export const FIRM_PRIMARY_NAVIGATION_TEST_IDS = {
  accountSettings: 'firm-primary-navigation__account-settings',
  addCompany: 'firm-primary-navigation__add-company',
  appSwitcher: 'firm-primary-navigation__app-switcher',
  appSwitcherScalar: 'firm-primary-navigation__app-switcher-scalar',
  appSwitcherWorkboard: 'firm-primary-navigation__app-switcher-workboard',
  addFirm: 'firm-primary-navigation__add-firm',
  addMeasurementDate: 'firm-primary-navigation__add-measurement-date',
  deleteCompany: 'firm-primary-navigation__delete-company',
  deleteMeasurementDate: 'firm-primary-navigation__delete-measurement-date',
  auditLogs: 'firm-primary-navigation__audit-logs',
  compGroups: 'firm-primary-navigation__comp-groups',
  companyChip: 'firm-primary-navigation__company-chip',
  companyMenu: 'firm-primary-navigation__company-menu',
  companyOption: (companySlug: string) => `firm-primary-navigation__company-${companySlug}`,
  companyPageLink: (companySlug: string, pageTitle: string) =>
    `firm-primary-navigation__company-${companySlug}-page-${pageTitle.toLowerCase().replace(/\s+/g, '-')}`,
  feedback: 'firm-primary-navigation__feedback',
  firmChip: 'firm-primary-navigation__firm-chip',
  firmOption: (firmSlug: string) => `firm-primary-navigation__firm-${firmSlug}`,
  firmProfile: 'firm-primary-navigation__firm-profile',
  firmSettings: 'firm-primary-navigation__firm-settings',
  firmSettingsMenu: 'firm-primary-navigation__firm-settings-menu',
  firmSwitcherMenu: 'firm-primary-navigation__firm-switcher-menu',
  measurementDateChip: 'firm-primary-navigation__measurement-date-chip',
  measurementDateMenu: 'firm-primary-navigation__measurement-date-menu',
  measurementDateOption: (measurementDateId: number | string) =>
    `firm-primary-navigation__measurement-date-${measurementDateId}`,
  optionsButton: 'firm-primary-navigation__options-button',
  userMenuButton: 'firm-primary-navigation__user-menu-button',
  optionsMenu: 'firm-primary-navigation__options-menu',
  productTours: 'firm-primary-navigation__product-tours',
  productToursMenu: 'firm-primary-navigation__product-tours-menu',
  scim: 'firm-primary-navigation__scim',
  sso: 'firm-primary-navigation__sso',
  signOut: 'firm-primary-navigation__sign-out',
  switchFirm: 'firm-primary-navigation__switch-firm',
  userAvatar: 'firm-primary-navigation__user-avatar',
  userAvatarFallback: 'firm-primary-navigation__user-avatar-fallback',
  userManagement: 'firm-primary-navigation__user-management',
} as const;
